export default {
  //top-nav
  navHome: "首頁",
  navProspect: "潛在客戶",
  navCompanies: "公司",
  navEnrich: "數據豐富",
  navIntent: "網站意圖",
  navSequence: "工作流程",
  navInbox: "收件匣",
  navInboxDesc: "在一個地方閱讀和回覆郵件和 LinkedIn 訊息",
  inboxSearchPlaceholder: "搜尋對話",
  inboxEmptyState: "暫無對話。當您的工作流程開始運行後,回覆將在這裡顯示。",
  inboxEmptyConnectCta: "設定工作流程",
  channelEmail: "郵件",
  channelLinkedIn: "領英",
  inboxMsgYou: "您",
  inboxSelectThreadTitle: "選擇一個對話",
  inboxThreadErrorTitle: "無法載入此對話",
  inboxThreadErrorHint: "此對話沒有可用的頻道連線，或資料已不再可用。",
  inboxComposerHint: "按 ⌘ + Enter 傳送",
  inboxToggleProspect: "切換潛在客戶詳情",
  inboxChannelFilter: "頻道篩選",
  inboxProspectContact: "聯絡方式",
  inboxProspectSequence: "工作流程",
  inboxProspectActivity: "動態",
  inboxProspectLastInbound: "最近回覆",
  inboxProspectLastOutbound: "最近傳送",
  inboxProspectStatus: "狀態",
  inboxProspectNoContact: "暫無聯絡方式。",
  inboxBulkSelected: "已選擇",
  inboxBulkMarkRead: "已讀",
  inboxBulkToggle: "選擇對話",
  inboxTabProfile: "資料",
  inboxTabActivity: "動態",
  inboxActivityEmpty: "此對話暫無動態。",
  inboxInsertVariable: "變數",
  inboxVarFullName: "全名",
  inboxVarCompany: "公司",
  inboxVarTitle: "職位",
  inboxSequenceStep: "步驟",
  inboxSequenceRunning: "執行中",
  inboxSequencePaused: "已暫停",
  inboxSequenceFinished: "已完成",
  inboxSequenceArchived: "已封存",
  inboxAsideConversations: "個對話",
  inboxBulkToggleAll: "選擇本頁全部",
  inboxSortBy: "排序",
  inboxSortRecent: "最新優先",
  inboxSortOldest: "最早優先",
  inboxSortSender: "寄件者 (A→Z)",
  inboxSortSubject: "主旨 (A→Z)",
  inboxSortReplied: "已回覆優先",
  last_message_at: "最新訊息",
  first_message_at: "首條訊息",
  reference_id: "寄件者",
  subject: "主旨",
  inboxAccountSingular: "個帳號",
  inboxAccountPlural: "個帳號",
  inboxRecentReplies: "最近回覆",
  inboxConnectedAs: "連接自",
  inboxActionInterested: "標記為感興趣",
  inboxActionMarkAll: "全部標記",
  inboxSelectThreadHint: "請選擇一個對話以查看訊息。",
  inboxReplyPlaceholder: "輸入回覆…",
  inboxSuggestReply: "AI 建議回覆",
  inboxSend: "發送",
  inboxFilterAll: "全部",
  inboxFilterUnread: "未讀",
  inboxFilterReplied: "已回覆",
  inboxFilterSnoozed: "稍後處理",
  inboxFilterClosed: "已關閉",
  inboxActionSnooze: "稍後處理",
  inboxActionMeetingBooked: "標記為已預約會議",
  inboxActionNotInterested: "標記為不感興趣",
  inboxActionArchive: "封存",
  inboxActionStopSequence: "停止工作流程",
  inboxArchetypeConcise: "簡潔",
  inboxArchetypeWithCta: "附帶呼籲",
  inboxArchetypeQuestionBack: "反問",
  actions: "操作",
  loading: "載入中…",
  navService: "企業服務",
  navAccountCredit: "帳戶信用點",
  navSetting: "設定",
  navSequenceDetail: "工作流程詳情",
  companyDetail: "公司詳情",

  // nav desc
  filterYourSearchToFindPreciselyTargeted:
    "篩選您的搜索，以找到目標明確的公司清單",
  filterYourSearchToFindHighlySpecific:
    "篩選您的搜索，以找到高度特定的目標潛在客戶群",
  instantlyEnhanceYourData:
    "通過添加來自各種來源的有價值的見解和關鍵細節，立即增强您的數據",
  transformAnonymousWebsiteTrafficInto:
    "通過添加來自各種來源的有價值的見解和關鍵細節，立即增强您的數據",
  personalizeYourOutreach:
    "自動化和個性化您的外展活動，以節省時間並吸引潛在客戶",
  comprehensiveBusinessSolutions: "滿足您需求的全面業務解決方案和支持服務",
  b2bLeadsWithRealtimeIdentification: "實時識別的B2B潛在客戶",
  discoverAndConnectWithPotentialBuyers: "發現並與潛在客戶聯繫",
  activelySeekingYourSolutionToday: "今天積極尋求您的解決方案",
  Market_Intent: "市場意圖",
  Tools: "工具",
  technologyLookup: "技術查詢",
  domainLookup: "域名查詢",
  emailVerification: "電子郵件驗證",
  upgrade: "升級",
  helpCenter: "幫助中心",
  contactUs: "聯繫我們",
  feedback: "反饋",
  hello: "你好",
  clickToChange: "點擊更改",
  yourProfile: "您的個人資料",
  currentUsage: "當前使用情況",
  upgradePlan: "升級計劃",
  integrations: "集成",
  featureRequests: "功能請求",
  change: "更改",
  en: "英文",
  cn: "中文（简）",
  tw: "中文（繁）",
  logout: "登出",
  switchLanguage: "成功切換語言",

  // button operation
  btnEdit: "編輯",
  btnDelete: "删除",
  btnCancel: "取消",
  btnFilters: "篩選",
  btnView: "查看",
  btnAdd: "添加",
  btnRemove: "移除",

  // 操作提示
  removeSuccessfully: "移除成功",
  saveSuccessfully: "保存成功",
  createSuccessfully: "創建成功",

  // 系统popup
  unableToProcessPayment: "無法處理付款：無法在您最近的支付中上完成付款。",
  billingSettings: "帳單設定",

  // wallet
  topupCredit: "充值信用點",
  autoTopup: "自動充值",
  lastCalculated: "最後計算時間",
  Enabled: "是",
  Disabled: "否",

  // user
  btnUpgrade: "升級",

  // app update toast
  newVersionAvailable:
    "<strong>新版本已發布</strong> — 重新載入以取得最新功能和修正。本頁未儲存的變更可能會遺失。",
  Reload: "重新載入",
  // TODO: translate (placeholders copied from en.js)
  inboxStatsToday: "Today",
  inboxStatsReplies: "Replies",
  inboxStatsPending: "Pending",
  inboxStatsActiveSequences: "Active sequences",
  inboxOpenEmpty: "Open the inbox to see your latest replies.",
  inboxRefresh: "Refresh inbox",
  inboxSuggestFollowUp: "Suggest follow-up",
  inboxInsightAge: "Age",
  inboxSuggestModePick: "Choose draft type",
  inboxSuggestModeReply: "Reply (prospect wrote last)",
  inboxSuggestModeFollowUp: "Follow-up (we wrote last)",
  inboxSuggestModeAuto: "Auto (detect from thread)",
  inboxFilterArchived: "Archived",
  inboxFilterDone: "Done",
  inboxStatusMeetingBooked: "Meeting booked",
  inboxStatusNotInterested: "Not interested",
  inboxStatusInterested: "Interested",
  inboxFilterOpen: "Active",
  inboxMsgSent: "Sent",
  inboxClickToOpen: "Click to open",
  inboxKpiSentToday: "Sent today",
  inboxKpiUnread: "Unread",
  inboxKpiRepliedToday: "Replies",
  inboxKpiSentWeek: "Sent this week",
  inboxKpiInbox: "in inbox",
  inboxKpiTotal: "total",
  inboxGlanceTopSequences: "Top sequences (30 days)",
  inboxLinkBtn: "Link",
  inboxLinkPromptUrl: "Link URL",
  inboxLinkPromptErr: "Enter a URL starting with http(s)://",
  inboxComposerDropHint: "Drop to attach",
  inboxFilterChannel: "Channel",
  inboxFilterCredential: "Credential",
  inboxFilterSequence: "Sequence",
  inboxFilterStatus: "Status",
  inboxFilterClassification: "Reply type",
  inboxFilterDateRange: "Date range",
  inboxFilterDateRangePh: "Pick a date range",
  inboxFilterClass_real: "Real replies only",
  inboxFilterClass_bounce: "Bounces",
  inboxFilterClass_auto_reply: "Auto-replies",
  inboxClassBounce: "Bounce",
  inboxClassBounceHint: "Delivery failed — this isn't a real reply",
  inboxClassAutoReply: "Auto-reply",
  inboxClassAutoReplyHint: "Automated out-of-office / vacation responder",
  inboxStepEvents: "events",
  inboxBulkMarkUnread: "Unread",
  inboxBulkInterested: "Interested",
  inboxBulkNotInterested: "Not interested",
  inboxSnoozeDialogTitle: "Snooze until",
  inboxSnoozeCustom: "Pick a custom date and time",
  inboxSnoozeCustomPh: "Select date & time",
  inboxSnoozeConfirm: "Snooze",
  inboxSnoozePreset1h: "Later today (1h)",
  inboxSnoozePreset4h: "Later today (4h)",
  inboxSnoozePresetTom: "Tomorrow morning",
  inboxSnoozePresetMon: "Next Monday",
  inboxSnippetBtn: "Snippets",
  inboxSnippetSearch: "Search snippets",
  inboxSnippetNew: "New snippet",
  inboxSnippetManage: "Manage",
  inboxSnippetCreate: "Create your first snippet",
  inboxSnippetCreateTitle: "New snippet",
  inboxSnippetEditTitle: "Edit snippet",
  inboxSnippetManager: "Manage snippets",
  inboxSnippetEmpty: "No saved snippets yet.",
  inboxSnippetFieldName: "Name",
  inboxSnippetFieldChannel: "Channel (optional)",
  inboxSnippetFieldBody: "Body",
  inboxSnippetChannelAny: "Any channel",
  inboxSnippetNamePh: "e.g. Friendly follow-up",
  inboxSnippetBodyPh: "Hi {{first_name}}, just following up…",
  btnSave: "Save",
  inboxProspectTracking: "Tracking",
  inboxOpened: "Opened",
  inboxClicked: "Clicked",
  inboxLast: "last",
  of: "of",
  inboxAttachBtn: "Attach",
  inboxAttachTooBig: "Total attachment size exceeds 24MB.",
  noData: "No results",
  inboxCopy: "Copy",
  inboxCopied: "Copied",
  inboxCopyEmail: "Copy email",
  inboxCopiedEmail: "Email copied",
  inboxCopyPhone: "Copy phone",
  inboxCopiedPhone: "Phone copied",
  inboxOpenLinkedIn: "Open LinkedIn",
  inboxOpenTwitter: "Open X / Twitter",
  inboxProspectCompany: "Company",
  inboxProspectInsights: "Insights",
  inboxInsightMessages: "Messages",
  inboxInsightSince: "Open",
  inboxAgeToday: "Today",
  inboxEmptyTitle: "No conversations yet",
  inboxSelectionPicker: "Selection options",
  inboxSelectionTitle: "Select conversations",
  inboxSelectThisPage: "This page",
  inboxSelectAll: "All conversations",
  inboxSelectCustom: "Custom",
  inboxSelectAllHint:
    "Selecting beyond this page fetches additional pages from the server.",
  applySelection: "Apply",
  theQuantityCannotBeZero: "Pick a non-zero count",
  inboxCompanyName: "Name",
  inboxCompanyIndustry: "Industry",
  inboxCompanySize: "Size",
  inboxCompanyLocation: "Location",
  inboxCompanyWebsite: "Website",
  inboxCompanyLinkedIn: "LinkedIn",
  inboxShowTrimmed: "Show trimmed content",
  inboxShowTrimmedHint: "Show the rest of this message",
  inboxFieldTo: "To",
  inboxFieldToPh: "recipient@example.com",
  inboxFieldToLinkedInPh: "Recipient",
  inboxFieldCc: "Cc",
  inboxFieldCcPh: "cc@example.com, …",
  inboxFieldBcc: "Bcc",
  inboxFieldBccPh: "bcc@example.com, …",
  inboxFieldSubject: "Subject",
  inboxFieldSubjectPh: "Subject",
  inboxFieldLocked: "Auto-filled — cannot edit",
  inboxTrackSent: "Sent",
  inboxTrackSentHint: "Messages we sent in this thread",
  inboxTrackReplies: "Replies",
  inboxTrackRepliesHint: "Inbound messages from the prospect",
  inboxTrackOpens: "Opens",
  inboxTrackOpensHint: "Times the recipient opened a tracked message",
  inboxTrackClicks: "Clicks",
  inboxTrackClicksHint: "Tracked links the recipient clicked",
  inboxTrackReads: "Reads",
  inboxTrackReadsHint:
    "Times the recipient read this thread (LinkedIn read receipts)",
  inboxTrackReactions: "Reactions",
  inboxTrackReactionsHint: "Reactions on our outbound messages",
  inboxMsgNoOpenYet: "No opens recorded yet",
  inboxMsgNoClickYet: "No clicks recorded yet",
  inboxActivityReplyReceived: "Reply received",
  inboxActivityOpenRecorded: "Email opened",
  inboxActivityClickRecorded: "Link clicked",
  inboxActivitySendEmail: "Email sent",
  inboxActivitySendLinkedIn: "LinkedIn message sent",
  inboxActivitySendInvite: "LinkedIn invite sent",
  inboxActivityFailed: "failed",
  inboxComposerExpand: "Expand composer",
  inboxComposerCollapse: "Collapse composer",
  inboxComposerMinimise: "Minimise composer",
  inboxComposerRestore: "Restore composer",
  inboxComposerReply: "Reply…",
  inboxReplyModeReply: "Reply",
  inboxReplyModeReplyAll: "Reply all",
  inboxRecipientNoMatch: "Type an email and press Enter",
  inboxSignatureToggle: "Toggle signature",
  inboxSignatureTitle: "Email signature",
  inboxSignaturePh: "Best regards,\nYour name",
  inboxSignatureOn: "Signature ON — click to remove",
  inboxSignatureOff: "Signature OFF — click to insert",
  inboxSignatureRightClickEdit: "right-click to edit",
  inboxSignatureRightClickHint:
    "Tip: right-click the signature button to edit.",
  Refresh: "Refresh",
  Show: "Show",
  Hide: "Hide",
  Next: "Next",
  // pagination
  pagination_per_page: "{size} / 頁",
  pagination_go_to: "前往",
};
